import styles from "./styles.module.scss";

type Props = {
  title: string;
  icon?: React.ReactNode;
  value: string | React.ReactNode;
  width?: number;
};

const StatsBlock: React.FC<Props> = ({ title, icon, value, width }) => {
  return (
    <div style={{ width, minWidth: width }} className={styles.wrapper}>
      <div className={styles.iconContainer}>{icon}</div>
      <div className={styles.infoBlock}>
        <span>{title}</span>
        <p>{value}</p>
      </div>
    </div>
  );
};

export default StatsBlock;
